import { Activity } from '@bizzabo/entities';

export type TimeSlot = {
    time: Date;
    text?: string;
    overlapSessions?: Activity[];
};

export interface TimesGroup {
    day: number;
    times: TimeSlot[];
}

export enum ParticipantRole {
    ATTENDEE_HOST = 'ATTENDEE_HOST',
    ATTENDEE_GUEST = 'ATTENDEE_GUEST',
}

export enum StatusMeeting {
    APPROVED_INVITE_TO = 'APPROVED_INVITE_TO',
    DECLINED_INVITE_TO = 'DECLINED_INVITE_TO',
    DELETED_INVITE_TO = 'DELETED_INVITE_TO',
    GOT_APPROVAL_FOR = 'GOT_APPROVAL_FOR',
    GOT_CANCELLATION_FOR = 'GOT_CANCELLATION_FOR',
    GOT_INVITE_CANCELLATION_FOR = 'GOT_INVITE_CANCELLATION_FOR',
    GOT_INVITE_FOR = 'GOT_INVITE_FOR',
    GOT_REJECTION_FOR = 'GOT_REJECTION_FOR',
    HAS_CANCELLED = 'HAS_CANCELLED',
    SENT_INVITE_TO = 'SENT_INVITE_TO',
}

export type ScheduledMeetingParticipant = {
    userProfileId: number;
    role: ParticipantRole;
    status: StatusMeeting;
};

export enum LocationType {
    Physical = 'PHYSICAL',
    Virtual = 'VIRTUAL',
}

export enum MeetingStatus {
    PENDING = 'PENDING',
    SCHEDULED = 'SCHEDULED',
    CANCELLED = 'CANCELLED',
}

export enum NotificationType {
    MEETING_CHANGED = 'MEETING_CHANGED',
}

export interface MeetingNotification {
    notificationId: string;
    notificationType: NotificationType;
}

export type ScheduledMeeting = {
    id: string;
    status: MeetingStatus;
    participants: ScheduledMeetingParticipant[];
    title: string;
    startDate?: Date;
    endDate?: Date;
    locationType: LocationType;
    physicalLocation?: string;
    intro?: string;
    description?: string;
    times?: Date[];
    duration?: number;
    notifications?: MeetingNotification[];
    created?: Date;
    modified?: Date;
};
